"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Google = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#4285F4",
        d: "M22.038 12.235c0-.876-.07-1.516-.223-2.18h-9.918v3.958h5.822c-.118.984-.752 2.465-2.16 3.46l-.02.133 3.136 2.453.218.022c1.994-1.861 3.145-4.598 3.145-7.846Z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#34A853",
        d: "M11.897 22.664c2.852 0 5.246-.948 6.995-2.583l-3.333-2.608c-.892.628-2.09 1.067-3.662 1.067-2.794 0-5.164-1.86-6.01-4.432l-.124.01-3.26 2.549-.043.12c1.737 3.483 5.305 5.877 9.437 5.877Z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#FBBC05",
        d: "M5.887 14.108a6.623 6.623 0 0 1-.352-2.11c0-.734.129-1.445.34-2.109l-.005-.141-3.302-2.589-.108.052a10.76 10.76 0 0 0-1.127 4.787c0 1.719.411 3.343 1.127 4.788l3.427-2.678Z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#EB4335",
        d: "M11.897 5.457c1.983 0 3.322.865 4.084 1.588l2.982-2.939c-1.832-1.718-4.214-2.773-7.066-2.773-4.132 0-7.7 2.394-9.437 5.878L5.875 9.89c.858-2.571 3.228-4.432 6.022-4.432Z"
      }
    )
  );
};
export default Google;
